module.exports = __webpack_public_path__ + "media/images/emblems/Chamblon-coat_of_arms-e075a4aa862b5e2a12415bf95526d1b6.svg";